import { createContext, Dispatch, SetStateAction } from 'react';
import {
  ILiveChat,
  IMessage,
  INlpResponse,
  ITopic,
  ITopicGroup,
  ITopicTag,
  TNullable,
} from '@common/types';

interface IChatContext {
  topics: Array<ITopic>;
  topicGroups: Array<ITopicGroup>;
  topicTags: Array<ITopicTag>;
  selectedTopic: string;
  setSelectedTopic: Dispatch<SetStateAction<string>>;
  messages: Array<IMessage>;
  responses: Array<{ id: number; response: INlpResponse }>;
  addMessage: (message: IMessage) => void;
  addResponse: (id: number, response: INlpResponse) => void;
  agreedToDisclaimer: boolean;
  setAgreedToDisclaimer: (newValue: TNullable<boolean>) => void;
  agreedToDisclaimerPerSession: boolean;
  setAgreedToDisclaimerPerSession: (newValue: boolean) => void;
  showAgreementBanner: boolean;
  setShowAgreementBanner: Dispatch<SetStateAction<boolean>>;
  liveChat: ILiveChat;
}

const initialState: IChatContext = {
  topics: [],
  topicGroups: [],
  topicTags: [],
  selectedTopic: '',
  setSelectedTopic: () => '',
  messages: [],
  addMessage: () => null,
  responses: [],
  addResponse: () => null,
  agreedToDisclaimer: false,
  setAgreedToDisclaimer: () => null,
  agreedToDisclaimerPerSession: false,
  setAgreedToDisclaimerPerSession: () => null,
  showAgreementBanner: false,
  setShowAgreementBanner: () => null,
  liveChat: {
    enabled: false,
    status: 'idle',
    agent: null,
    isActive: false,
    canStart: false,
    canSend: false,
    start: async () => undefined,
    sendMessage: async () => undefined,
    end: async () => undefined,
  },
};

export default createContext<IChatContext>(initialState);
